import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsListItemName = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-name", { ref: ref }, children));
};
export default VeltNotificationsPanelContentDocumentsListItemName;
